import { useMemo } from "react";

export const isErrorFormGroup = (severity, helpBlock) => (severity === 'error' || severity === 'warning') && !!helpBlock;

/**
 * Création d'une valeur utilisable comme un id à partir d'un string arbitraire.
 */
export const normalizeToId = (str) => str.replace(/\s/g, '-');

/**
 * Hook permettant la génération des identifiants utilisés pour lier les champs
 * @param {string} name -  Nom du champ, utilisé comme base
 * @param {string[]} items - liste des elements
 * @returns Ensemble des identifiants
 */
export const useIds = (name, ...items) => {
    const normalizedName = normalizeToId(name);

    return useMemo(
        () => items.reduce((acc, key) => ({...acc, [key]: `${normalizedName}-${key}`}),{},),
        [items, normalizedName],
    );
};

export const isLabelProps = (label) => label.children !== undefined;

// Severity level.
export const SEVERITY_MAPPING = {
    success: 'has-success',
    warning: 'has-warning',
    error: 'has-error',
  };

export const extractFormGroupProps = (props) => {
    const { label, name, severity, helpInput, helpBlock } = props;
    return { label, name, severity, helpInput, helpBlock };
}

export const lowerCaseFilter = (option, value) =>
    option.label.toLowerCase().indexOf(value.toLowerCase()) > -1;
